import script from "./DatasetChangeLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetChangeLogs.vue?vue&type=script&setup=true&lang=js"

import "./DatasetChangeLogs.vue?vue&type=style&index=0&id=fee21ef0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fee21ef0"]])

export default __exports__